import React, { useState } from "react";
import refresh from "../Images/refresh.png";
import btc from "../Images/btc.png";
import arrow_one from "../Images/arrow-one.png";
import arrow_two from "../Images/arrow-two.png";
import BidsCard from "../components/BidsCard";

const Partnerspage = () => {
	const [value, setValue] = useState({
		price: "0.1",
	});

	const handleChange = (e) => {
		let newState = { ...value };
		newState[e.target.name] = e.target.value;
		setValue({
			...newState,
		});
	};
	return (
		<div className="marketplace">
			<div className="marketplace__container">
				<div className="marketplace__heroContainer">
					<div className="marketplace__hero">
						<p className="marketplace__hero__heading">
							Currency <span>Swapping</span> is easier than ever...
						</p>

						<div className="rates__hero__commodity">
							<div className="rates__hero__commodityTop">
								<div className="rates__hero__commodityLeft">
									<p>Commodity you are changing from</p>
									<div className="rates__hero__selection">
										<input type="number" name="" id="" value="0.1" onChange={handleChange} />
										<img src={btc} alt="" />
										<select>
											<option value="USD">USD</option>
											<option value="EUR">EUR</option>
										</select>
									</div>
								</div>
								<img src={refresh} alt="refresh" />
								<div className="rates__hero__commodityRight">
									<p>Commodity you are changing to</p>
									<div className="rates__hero__selection">
										<input type="number" name="" id="" value="0.1" onChange={handleChange} />
										<img src={btc} alt="" />
										<select>
											<option value="EUR">EUR</option>
											<option value="USD">USD</option>
										</select>
									</div>
								</div>
							</div>

							<div className="rates__hero__commodityBottom">
								<button className="homepage__conversion__buy">
									BUY <img src={arrow_two} alt="" />
								</button>
								<button className="homepage__conversion__sell">
									SELL <img src={arrow_one} alt="" />
								</button>
							</div>
						</div>
					</div>
				</div>

				<div className="marketplace__bid">
					<div className="marketplace__bidTop">
						<p>Available Bids from Organisation</p>
						<button>View More</button>
					</div>
					<div className="marketplace__bidBottom">
						<BidsCard />
						<BidsCard />
						<BidsCard />
						<BidsCard />
						<BidsCard />
					</div>
				</div>

				<div className="marketplace__bid">
					<div className="marketplace__bidTop">
						<p>Available Bids from Organisation</p>
						<button>View More</button>
					</div>
					<div className="marketplace__bidBottom">
						<BidsCard />
						<BidsCard />
						<BidsCard />
						<BidsCard />
						<BidsCard />
					</div>
				</div>

				<div className="marketplace__bid">
					<div className="marketplace__bidTop">
						<p>Available Bids from Organisation</p>
						<button>View More</button>
					</div>
					<div className="marketplace__bidBottom">
						<BidsCard />
						<BidsCard />
						<BidsCard />
						<BidsCard />
						<BidsCard />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Partnerspage;
